import { App as AntApp } from 'antd';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n';
import AppErrorBoundary from '../AppErrorBoundary.jsx';
import IndustryProvider from './IndustryProvider.jsx';
import ThemeProvider from './ThemeProvider.jsx';
import QueryProvider from './QueryProvider.jsx';
import StoreContextBootstrap from './StoreContextBootstrap.jsx';
import DocumentHead from './DocumentHead.jsx';
import SentryBootstrap from './SentryBootstrap.jsx';
import AnalyticsBootstrap from './AnalyticsBootstrap.jsx';
import SwUpdatePrompt from './SwUpdatePrompt.jsx';
import DevAuthBootstrap from './DevAuthBootstrap.jsx';
import FavoritesBootstrap from './FavoritesBootstrap.jsx';
import ProfileBootstrap from './ProfileBootstrap.jsx';
import StoreSelectionProvider from './StoreSelectionProvider.jsx';
import NativeDeepLinkBootstrap from './NativeDeepLinkBootstrap.jsx';
import ScrollToTop from './ScrollToTop.jsx';

export default function AppProviders({ children }) {
  return (
    <AppErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <IndustryProvider>
          <StoreContextBootstrap>
            <ThemeProvider>
              <QueryProvider>
                <AntApp>
                  <SentryBootstrap />
                  <AnalyticsBootstrap />
                  <DevAuthBootstrap />
                  <FavoritesBootstrap />
                  <ProfileBootstrap />
                  <DocumentHead />
                  <SwUpdatePrompt />
                  <NativeDeepLinkBootstrap />
                  <ScrollToTop />
                  <StoreSelectionProvider>{children}</StoreSelectionProvider>
                </AntApp>
              </QueryProvider>
            </ThemeProvider>
          </StoreContextBootstrap>
        </IndustryProvider>
      </I18nextProvider>
    </AppErrorBoundary>
  );
}
